import axios from 'axios';

const BASE_URL = '/app/internalFormFunnel';

export const createInternalForm = async (funnelId, name) => {
    const { data } = await axios.post(`${BASE_URL}/?funnelId=${funnelId}`, name, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const saveInternalFormOptions = async (internalFormId, funnelId, dupCheckOptionString) => {
    const { data } = await axios.put(`${BASE_URL}/${internalFormId}/${funnelId}`, dupCheckOptionString, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const syncInternalFormLabel = async (cell) => {
    const internalFormId = cell.value?.internalFormId ?? 0;
    const newName = cell.value?.name ?? '';

    if (internalFormId && newName) {
        await axios.put(`${BASE_URL}/${internalFormId}/name`, newName, {
            headers: {
                'Content-Type': 'text/html',
            },
        });
    }
};
